import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e7805fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "staff" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "STAFF PORTAL", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { inject, onBeforeMount, ref, reactive } from 'vue'
    import type { TabsPaneContext } from 'element-plus'
    import { useRoute, useRouter } from 'vue-router'
  
    import CardText from '@/components/CardText.vue'
    import LoginForm from '@/components/LoginForm.vue'
    import Document from '@/components/Document.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'WapStaffPortalView',
  setup(__props) {

    const $axios : any = inject('axios');
  
    const route = useRoute();
    const router = useRouter();
  
    // const activeTab = typeof route.params.tab === 'string' ? route.params.tab : 'document';

    const isAdminValid = ref(false);
    const isOBAValid = ref(false);

    const handleClick = (tab: TabsPaneContext, event: Event) => {
        // console.log(isAdminValid.value, isOBAValid.value);  
    }

    // onBeforeMount(() => {
    //     $axios.get('/user/admin/validate').then((res: any) => {
    //         if (res.data.code === 200) {
    //             isAdminValid.value = true;
    //         }
    //         else {
    //             isAdminValid.value = false;
    //         }
    //     }).catch((err: any) => {
    //         isAdminValid.value = false;
    //     });

    //     $axios.get('/user/oba/validate').then((res: any) => {
    //         if (res.data.code === 200) {
    //             isOBAValid.value = true;
    //         }
    //         else {
    //             isOBAValid.value = false;
    //         }
    //     }).catch((err: any) => {
    //         isOBAValid.value = false;
    //     });
    // });
  
    const onBack = () => {
      router.back();
      // notify('Back')
    }
    
  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isAdminValid.value)
      ? (_openBlock(), _createBlock(Document, { key: 0 }))
      : (_openBlock(), _createBlock(LoginForm, {
          key: 1,
          style: {"padding":"0 2vh"}
        })),
    _hoisted_3
  ]))
}
}

})